import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div
                className="w-8 h-8 rounded-full flex items-center justify-center"
                style={{ backgroundColor: 'var(--color-primary-500)' }}
              >
                <span className="text-white font-bold text-sm">VR</span>
              </div>
              <span className="text-xl font-bold">Voice Restaurant</span>
            </div>
            <p className="text-gray-400 mb-4 max-w-md">
                Ordering system.             
            </p>
            <div className="text-sm text-gray-400">
              <p>📍 123 Tech Street, Innovation City</p>
              <p>📞 (555) 123-VOICE</p>
              <p>✉️ hello@voicerestaurant.com</p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/menu"
                  className="text-gray-400 transition-colors"
                  onMouseEnter={(e) => e.currentTarget.style.color = 'var(--color-primary-300)'}
                  onMouseLeave={(e) => e.currentTarget.style.color = ''}
                >
                  Menu
                </Link>
              </li>
              <li>
                <Link
                  to="/voice-order"
                  className="text-gray-400 transition-colors"
                  onMouseEnter={(e) => e.currentTarget.style.color = 'var(--color-primary-300)'}
                  onMouseLeave={(e) => e.currentTarget.style.color = ''}
                >
                  Voice Ordering
                </Link>
              </li>
              <li>
                <Link
                  to="/order-tracking"
                  className="text-gray-400 transition-colors"
                  onMouseEnter={(e) => e.currentTarget.style.color = 'var(--color-primary-300)'}
                  onMouseLeave={(e) => e.currentTarget.style.color = ''}
                >
                  Track Order
                </Link>
              </li>
              <li>
                <Link
                  to="/profile"
                  className="text-gray-400 transition-colors"
                  onMouseEnter={(e) => e.currentTarget.style.color = 'var(--color-primary-300)'}
                  onMouseLeave={(e) => e.currentTarget.style.color = ''}
                >
                  My Account
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Support</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="#"
                  className="text-gray-400 transition-colors"
                  onMouseEnter={(e) => e.currentTarget.style.color = 'var(--color-primary-300)'}
                  onMouseLeave={(e) => e.currentTarget.style.color = ''}
                >
                  Help Center
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-400 transition-colors"
                  onMouseEnter={(e) => e.currentTarget.style.color = 'var(--color-primary-300)'}
                  onMouseLeave={(e) => e.currentTarget.style.color = ''}
                >
                  Voice Commands
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-400 transition-colors"
                  onMouseEnter={(e) => e.currentTarget.style.color = 'var(--color-primary-300)'}
                  onMouseLeave={(e) => e.currentTarget.style.color = ''}
                >
                  Accessibility
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-400 transition-colors"
                  onMouseEnter={(e) => e.currentTarget.style.color = 'var(--color-primary-300)'}
                  onMouseLeave={(e) => e.currentTarget.style.color = ''}
                >
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Voice Features */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="text-center">
            <h4 className="text-lg font-semibold mb-4">🎤 Voice Commands You Can Use</h4>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm text-gray-400">
              <div>
                <p className="font-medium text-white mb-2">Ordering</p>
                <p>"I want a pizza"</p>
                <p>"Add a burger to my order"</p>
                <p>"Show me the menu"</p>
              </div>
              <div>
                <p className="font-medium text-white mb-2">Modifications</p>
                <p>"Extra cheese please"</p>
                <p>"Make it spicy"</p>
                <p>"No onions"</p>
              </div>
              <div>
                <p className="font-medium text-white mb-2">Checkout</p>
                <p>"Confirm my order"</p>
                <p>"Cash on delivery"</p>
                <p>"Check my total"</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="text-sm text-gray-400 mb-4 md:mb-0">
            © 2024 Voice Restaurant. All rights reserved.
          </div>
          <div className="flex space-x-6 text-sm text-gray-400">
            <a
              href="#"
              className="transition-colors"
              onMouseEnter={(e) => e.currentTarget.style.color = 'var(--color-primary-300)'}
              onMouseLeave={(e) => e.currentTarget.style.color = ''}
            >
              Privacy Policy
            </a>
            <a
              href="#"
              className="transition-colors"
              onMouseEnter={(e) => e.currentTarget.style.color = 'var(--color-primary-300)'}
              onMouseLeave={(e) => e.currentTarget.style.color = ''}
            >
              Terms of Service
            </a>
            <a
              href="#"
              className="transition-colors"
              onMouseEnter={(e) => e.currentTarget.style.color = 'var(--color-primary-300)'}
              onMouseLeave={(e) => e.currentTarget.style.color = ''}
            >
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;